import { CircleCheck, KeyRound } from 'lucide-react';
import { useState } from 'react';

import { Button } from '@/design-system/ui/Button';
import { confirmPasswordReset } from '@/services/api/session';

import AuthFrame from './components/AuthFrame';
import NewPasswordForm from './components/NewPasswordForm';

/**
 * Senha nova pelo link do e-mail (`/redefinir-senha?token=…`). Ao salvar, as sessões dos
 * outros aparelhos são encerradas e a pessoa volta para entrar com a senha nova.
 */
export default function SetPassword({ token, onDone }: { token: string; onDone: () => void }) {
  const [saved, setSaved] = useState(false);

  if (saved) {
    return (
      <AuthFrame title="Senha alterada">
        <div role="status" className="flex flex-col items-center gap-4.5 text-center">
          <span className="grid size-14 place-items-center rounded-block bg-success-soft text-success">
            <CircleCheck aria-hidden className="size-6.5 stroke-[1.8]" />
          </span>
          <h1 className="m-0 text-title-sm font-extrabold tracking-[-0.03em]">Senha alterada</h1>
          <p className="m-0 text-body text-ink-secondary">
            Entre com a senha nova. As sessões abertas em outros aparelhos foram encerradas.
          </p>
          <Button className="h-11" onClick={onDone}>
            Ir para o login
          </Button>
        </div>
      </AuthFrame>
    );
  }

  return (
    <AuthFrame title="Criar senha nova">
      <div className="flex flex-col gap-1.5">
        <h1 className="m-0 text-display-lg leading-tight font-extrabold tracking-[-0.03em]">
          Criar senha nova
        </h1>
        <p className="m-0 text-body text-ink-subtle">
          Escolha a senha nova. As sessões abertas em outros aparelhos serão encerradas.
        </p>
      </div>
      <NewPasswordForm
        action={
          <>
            <KeyRound aria-hidden />
            Salvar senha
          </>
        }
        onSubmit={async (password) => {
          await confirmPasswordReset(token, password);
          setSaved(true);
        }}
      />
    </AuthFrame>
  );
}
